// Writing entry registry.
//
// Adding a new entry:
//   1. Drop a new file in this folder, e.g. `2026-06-04-my-note.jsx`.
//   2. Export a `meta` object (slug, title, summary, date, tags?) and a
//      default React component (the body).
//   3. Add the import below and append it to `ENTRIES`.
//
// Entries are sorted newest first by their `meta.date` (ISO YYYY-MM-DD).
// The slug must be URL-safe — it becomes the route at /Writing/:slug.

import * as helloWorld from "./2026-05-20-hello-world.jsx";
import * as onBlocks from "./2026-04-12-on-blocks.jsx";
import * as aSmallTool from "./2026-03-01-a-small-tool.jsx";

const RAW = [helloWorld, onBlocks, aSmallTool];

const ENTRIES = RAW
  .map((mod) => ({ meta: mod.meta, Component: mod.default }))
  .sort((a, b) => b.meta.date.localeCompare(a.meta.date));

export default ENTRIES;

export function getEntryBySlug(slug) {
  return ENTRIES.find((e) => e.meta.slug === slug) || null;
}
